<template>
  <div class="bg-white">
    <div>
      <BaseModal
        :open="open"
        @close="open = false"
      >
        <VacancyFilterList
          v-if="!refreshFilters"
          :filters="state.vacancySearch.filters"
          :sectors="sectorFilters"
          form-id="vacancy-filter-mobile"
          @update-filters="handleSubmit"
          @close-modal="open = false"
          @reset-filters="resetFilters"
        />
      </BaseModal>


      <div class="rounded-b-[2.75rem] bg-neutral-900 lg:rounded-b-[12.5rem]">
        <header class="container">
          <div class="mx-auto flex max-w-2xl flex-col items-center justify-center lg:py-32">
            <h1 class="mb-8 text-center text-white">
              Wij helpen jou aan de volgende stap
            </h1>
            <!-- Zit in het formulier hierboven <VacancyFilterList /> -->
            <!-- <FormKit
                placeholder="Zoek op vacaturetitel"
                inner-class="$reset !ring-0"
                input-class="$reset w-96 rounded-full bg-white p-4 pl-6"
                name="search"
                type="text"
                :delay="500"
              />-->
          </div>
        </header>
      </div>
    </div>

    <section
      id="top"
      class="container relative py-8"
    >
      <UiTag
        type="outline"
        class="mb-8 cursor-pointer font-medium lg:hidden"
        @click="open = !open"
      >
        Filter
        <Icon
          name="ph:sliders-horizontal"
          class="h-6 w-6"
        />
      </UiTag>
      <div class="gap-8 lg:grid lg:grid-cols-12">
        <aside class="sticky top-4 hidden h-fit space-y-4 lg:col-span-4 lg:block">
          <VacancyFilterList
            v-if="!refreshFilters"
            :filters="state.vacancySearch.filters"
            :sectors="sectorFilters"
            form-id="vacancy-filter-desktop"
            @update-filters="handleSubmit"
            @reset-filters="resetFilters"
          />
          <RecruiterTile
            :recruiter="recruiter"
            invert-next-logo
          />
        </aside>
        <div
          class="col-span-8"
        >
          <h4 class="mb-4">
            {{ totalVacancies }} vacatures gevonden
          </h4>
          <VacancyList
            :loading="vacancySearchLoading"
            :vacancies="vacancies"
          />
          <BasePagination
            v-if="vacancies.length"
            class="col-start-5 flex flex-row items-center justify-between pt-8"
            :page="page"
            :side-dot-size="PAGE_MARGIN"
            :size="Math.ceil(totalVacancies / ITEMS_PER_PAGE)"
            @page-change="changePage"
          />
        </div>
      </div>
    </section>

    <section class="px-4 pb-8">
      <RecruiterTile
        class="card-border mx-auto max-w-sm rounded-2xl lg:hidden"
        :recruiter="recruiter"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import {useRouteQuery} from '@vueuse/router';
import {useGtm} from '@gtm-support/vue-gtm';
import {
  useSectorFilterQuery,
  useRandomRecruiterQuery, useVacancySearchQuery,
} from '~/graphql/graphql.js';

useHead({
  link: [
    {rel: 'canonical', href: 'https://nextrecruitment.nl/vacatures'},
  ],
});

definePageMeta({
  header: {
    absolute: true,
    transparent: true,
    light: true,
  },
  bg: 'bg-white',
});

const route = useRoute();

const ITEMS_PER_PAGE = 10;
const PAGE_MARGIN = 2;

const routeFilter = useRouteQuery<string>('filters');
const page = ref(0);

const filters = computed(() => routeFilter.value ? JSON.parse(routeFilter.value) : {sector: [], hours: []});
const state = ref({
  vacancySearch: {
    filters: routeFilter.value ? JSON.parse(routeFilter.value) : {sector: [], hours: []},
    order: route.query?.order ?? (filters.value?.city ? '_geoPoint' : 'salary'),
    page,
    per_page: ITEMS_PER_PAGE,
  },
});

const open = ref(false);
const refreshFilters = ref(false);

const {result: vacancySearchResult, loading: vacancySearchLoading} = useVacancySearchQuery(state.value.vacancySearch);
const vacancies = computed(() => vacancySearchResult.value?.vacancySearch?.data ?? []);
const totalVacancies = computed(() => vacancySearchResult.value?.vacancySearch?.total ?? 0);

const {result: sectorFilterResult} = useSectorFilterQuery();
const sectorFilters = computed(() => sectorFilterResult.value?.sector ?? []);

const {result: recruiterResult} = useRandomRecruiterQuery();
const recruiter = computed(() => recruiterResult.value?.randomRecruiter ?? []);


const setFilters = (filters: VacancyFilters) => {
  state.value.vacancySearch.filters = filters;
  state.value.vacancySearch.order = route.query?.order ?? (filters?.city ? '_geoPoint' : 'salary');
  routeFilter.value = JSON.stringify(filters);
};

const handleSubmit = (data: VacancyFilters) => {
  setFilters(data);
  page.value = 0;
};

const resetFilters = () => {
  refreshFilters.value = true;
  setFilters({sector: [], hours: []});

  nextTick(() => {
    refreshFilters.value = false;
  });
};

const changePage = (newPage: number) => {
  page.value = newPage;
  const elem = document.getElementById('top');
  elem?.scrollIntoView({behavior: 'smooth', block: 'start'});
};

onMounted(() => {
  const gtm = useGtm();
  gtm?.trackEvent({event: 'view_item_list'});
});
</script>
